export default [
    {
        path: 'servico-manutencao',
        component: () => import(
            /* webpackChunkName: 'cadastro-servico-manutencao' */
            '@/views/cadastro/servico-manutencao/Index'
        ),
        redirect: 'servico-manutencao/index',
        children: [
            {
                name: 'cadastro-servico-manutencao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'cadastro-servico-manutencao' */
                    '@/views/cadastro/servico-manutencao/List.vue'
                ),
            },
            {
                name: 'cadastro-servico-manutencao-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'cadastro-servico-manutencao' */
                    '@/views/cadastro/servico-manutencao/Form.vue'
                ),
            },
            {
                name: 'cadastro-servico-manutencao-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'cadastro-servico-manutencao' */
                    '@/views/cadastro/servico-manutencao/Form.vue'
                ),
            },
        ],
    },
]